module.exports = __webpack_public_path__ + "static/media/FL_BNobleM_es15.76318603.png";